// Mobile gate. Touch-only devices (no mouse/trackpad, no hover)
// shouldn't load the game bundle — they get the desktop-only
// notice from index.html / style.css instead. The detection lives
// here (and not in an inline <script>) so a strict CSP with
// `script-src 'self'` doesn't block the bootstrap.
if (matchMedia('(pointer: coarse) and (hover: none)').matches) {
    document.documentElement.dataset.mobile = '1';
} else if (import.meta.env.DEV && new URLSearchParams(location.search).has('mixer')) {
    // Dev-only mixer mode: ?mixer in the URL bypasses the game and
    // loads the AXIS sample mixer instead. Dead code in production
    // because import.meta.env.DEV is statically false at build time.
    import('./mixer/index.js');
} else {
    // CSS is loaded via <link> in index.html so the mobile-only path
    // can render styled without booting the game. Loader stays
    // visible until the game module has evaluated and the soundtrack
    // samples are decoded.
    // import game module + wait for its re-exported pixi `ready`
    // promise before counting it as "loaded" — this is what gates
    // the loader-removal on Pixi being actually initialised, not
    // just on the JS bundle being parsed.
    const gameP = import('./game/index.js')
        .then(m => m.ready)
        .catch(err => { console.error('game/pixi init failed', err); });
    const trackP = import('./game/soundtrack.js')
        .then(m => m.ready)
        .catch(err => console.warn('soundtrack init failed, continuing', err));

    // Hard timeout: if either of the above stalls (e.g. a top-level
    // await inside a chunk never settles), remove the loader anyway
    // after 8 s. Cancel the timer once the boot resolves cleanly.
    let timeoutId;
    const timeoutP = new Promise(resolve => {
        timeoutId = setTimeout(() => {
            console.warn('boot timeout — removing loader anyway');
            resolve();
        }, 8000);
    });

    Promise.race([
        Promise.all([gameP, trackP]).then(() => clearTimeout(timeoutId)),
        timeoutP,
    ]).then(() => {
        requestAnimationFrame(() => {
            const loader = document.getElementById('loader');
            if (loader) loader.remove();
            document.body.style.visibility = 'visible';
        });
    });
}
